export function personTypeReducer( state = 0, action ){
    switch( action.type ){
        case "SET_PERSON_TYPE": return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/person-type-component/reducers.js